import UploadAdapter from './UploadAdapter';

export default function UploadAdapterPlugin(editor) {
    const uploadFrom = editor.config.get('uploadFrom') || 'desc';
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
        return new UploadAdapter(loader, uploadFrom);
    };
}
